import Model from "../../Model";

export interface TDebtObligation {
  applicantId: number;
  debtorName: string;
  creditor: string;
  debtValue: string;
  debtPeriod: string;
  description: string;
  leftToPay: string;
  paidDuringLastYear: string;
}

export interface IDebtObligation extends TDebtObligation {}

const DebtObligation = Model(
  (model: TDebtObligation): IDebtObligation => {
    const _debtObligation: TDebtObligation = Object.assign({}, model);

    return {
      get applicantId() {
        return _debtObligation.applicantId;
      },

      get debtorName() {
        return _debtObligation.debtorName;
      },

      get creditor() {
        return _debtObligation.creditor;
      },

      get debtValue() {
        return _debtObligation.debtValue;
      },

      get debtPeriod() {
        return _debtObligation.debtPeriod;
      },

      get description() {
        return _debtObligation.description;
      },

      get leftToPay() {
        return _debtObligation.leftToPay;
      },

      get paidDuringLastYear() {
        return _debtObligation.paidDuringLastYear;
      }
    };
  }
);
export default DebtObligation;
